import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useUserContext } from 'common/contexts/UserContext';
import * as React from 'react';

interface Props {
  selected: string[];
  onSelect: (emails: string[]) => void;
}

export const Emails: React.FC<Props> = (props) => {
  const { selected, onSelect } = props;
  const { user } = useUserContext();

  if (!user) {
    return null;
  }

  const teamEmails = user.teamMembers.map((p) => p.email) || [];
  const emails = [user.email, ...teamEmails.sort().filter((e) => e !== user.email)];

  return (
    <ToggleButtonGroup
      value={selected}
      onChange={(_, newEmails) => onSelect(newEmails)}
      className="flex flex-wrap gap-2 border border-gray-500 rounded p-2 overflow-scroll h-[114px]"
    >
      {emails.map((email) => (
        <ToggleButton
          key={email}
          value={email}
          size="small"
          classes={{
            root: 'bg-gray-50 font-normal text-gray-600 border border-gray-50 p-0 px-1',
            selected: 'text-blue-900 bg-blue-100',
          }}
        >
          {email}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};
Emails.displayName = 'SmartPerDiem.DownloadModal.Emails';
